export function VueIcon(props) {
  return (
    <svg width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8.3875 2.5L7 4.88125L5.6125 2.5H1L7 12.8125L13 2.5H8.3875Z" fill="#42B883" />
      <path d="M8.38749 2.5L6.99999 4.88125L5.61249 2.5H3.39999L6.99999 8.6875L10.6 2.5H8.38749Z" fill="#35495E" />
    </svg>
  );
}
